import React from 'react';
import { Loader2 } from 'lucide-react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  color?: 'primary' | 'white' | 'gray';
}

const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'md', 
  className = '',
  color = 'primary'
}) => {
  const sizeClasses = {
    sm: 16,
    md: 24,
    lg: 32,
    xl: 48
  };

  const colorClasses = {
    primary: 'text-blue-600',
    white: 'text-white',
    gray: 'text-gray-600'
  };

  return (
    <Loader2
      size={sizeClasses[size]}
      className={`animate-spin ${colorClasses[color]} ${className}`}
      role="status"
      aria-label="Cargando"
    />
  );
};

export default Spinner;
